"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultPage = void 0;
exports.Pagination = Pagination;
exports.toLimitAndOffset = toLimitAndOffset;
exports.toPageNumberSize = toPageNumberSize;
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const components_1 = require("./");
const Css_1 = require("../Css");
const inputs_1 = require("../inputs");
const utils_1 = require("../utils");
// Use OffsetAndLimit as our default b/c that's what backend filters expect
exports.defaultPage = { offset: 0, limit: 100 };
function Pagination(props) {
    const { totalCount, pageSizes = [100, 500, 1000] } = props;
    const [page, setPage] = props.page;
    const { pageSize, pageNumber } = toPageNumberSize(page);
    const pageOptions = pageSizes.map((size) => ({ id: size, name: String(size) }));
    const hasPrevPage = pageNumber > 1;
    const hasNextPage = pageNumber < totalCount / pageSize;
    // Create the `1 - 100 of 1000` or `0 of 0`
    const first = pageSize * (pageNumber - 1) + (totalCount ? 1 : 0);
    const last = Math.min(pageSize * pageNumber, totalCount);
    // When no rows, show '0 of 0' instead of '0 - 0 of 0'
    const showLast = totalCount > 0;
    // Convert the new page back to whatever format the caller wants
    function set(newPage) {
        if ("pageNumber" in props.page[0]) {
            setPage(newPage);
        }
        else {
            setPage(toLimitAndOffset(newPage));
        }
    }
    const tid = (0, utils_1.useTestIds)(props, "pagination");
    return ((0, jsx_runtime_1.jsxs)("div", { css: Css_1.Css.df.bcGray200.bt.xs.gray500.px2.pt2.$, ...tid, children: [(0, jsx_runtime_1.jsx)("div", { css: Css_1.Css.df.mya.mr2.$, ...tid.pageSizeLabel, children: "Page size:" }), (0, jsx_runtime_1.jsx)("div", { css: Css_1.Css.wPx(78).$, children: (0, jsx_runtime_1.jsx)(inputs_1.SelectField, { compact: true, label: "Page Size", labelStyle: "hidden", options: pageOptions, value: pageSize, onSelect: (val) => set({ pageNumber: 1, pageSize: val }), ...tid.pageSize }) }), (0, jsx_runtime_1.jsxs)("div", { css: Css_1.Css.mla.mya.df.$, children: [(0, jsx_runtime_1.jsxs)("div", { css: Css_1.Css.df.mya.mr2.$, ...tid.pageInfoLabel, children: [first, " ", showLast ? `- ${last}` : "", " of ", totalCount] }), (0, jsx_runtime_1.jsx)(components_1.IconButton, { icon: "chevronLeft", color: hasPrevPage ? Css_1.Palette.Blue700 : Css_1.Palette.Gray200, onClick: () => set({ pageNumber: pageNumber - 1, pageSize }), disabled: !hasPrevPage, ...tid.previousIcon }), (0, jsx_runtime_1.jsx)(components_1.IconButton, { icon: "chevronRight", color: hasNextPage ? Css_1.Palette.Blue700 : Css_1.Palette.Gray200, onClick: () => set({ pageNumber: pageNumber + 1, pageSize }), disabled: !hasNextPage, ...tid.nextIcon })] })] }));
}
function toLimitAndOffset(page) {
    return "limit" in page
        ? page
        : {
            // E.g. on first page the offset is 0, second page the offset is 100, then 200, etc.
            offset: (page.pageNumber - 1) * page.pageSize,
            limit: page.pageSize,
        };
}
function toPageNumberSize(page) {
    return "pageNumber" in page
        ? page
        : {
            pageNumber: Math.floor(page.offset / page.limit) + 1,
            pageSize: page.limit,
        };
}
